module.exports = __webpack_public_path__ + "static/media/imagen web alta 2.bc393b89.jpg";